import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchAdminTradierHistory } from '../../services/adminTradierHistoryService';
import { ADMIN_TRADE_HISTORY_START } from '../../utils/adminTradeHistoryWindow';
import { filterTradierHistoryToTracked } from '../../utils/adminTradeSymbols';

const toIsoDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const EMPTY = { loading: false, data: null, error: null, code: null, accountId: null };

/** One Tradier history request per selected client, shared by the header cards and the Tradier tab. */
export default function useAdminTradierHistory(userId) {
  const [state, setState] = useState(EMPTY);
  const currentUserId = useRef(userId);

  const load = useCallback(async () => {
    if (!userId) return;
    setState((s) => ({ ...s, loading: true, error: null, code: null }));
    const result = await fetchAdminTradierHistory({
      userId,
      start: toIsoDate(ADMIN_TRADE_HISTORY_START),
      end: toIsoDate(new Date()),
    });
    // Admins click through clients faster than a large history loads.
    if (currentUserId.current !== userId) return;
    setState({
      loading: false,
      data: result.data ? filterTradierHistoryToTracked(result.data) : null,
      error: result.error || null,
      code: result.code || null,
      accountId: result.data?.accountId || result.accountId || null,
    });
  }, [userId]);

  useEffect(() => {
    currentUserId.current = userId;
    setState(EMPTY);
    load();
  }, [userId, load]);

  return { ...state, reload: load };
}
